module.exports = __webpack_public_path__ + "img/intro_1.773524e3.jpg";